module.exports = __webpack_public_path__ + "static/usc-logo.1ca3171c.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/images/usc-logo.jpeg
// module id = 1159
// module chunks = 35783957827783